








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppRegularLink extends Vue {
  @Prop({ type: String, default: '' })
  readonly href!: string;

  @Prop({ type: String, default: '' })
  readonly mod!: string;

  get modClasses(): Array<string> {
    const { mod } = this;
    if (!mod.length) return [];
    return mod.split(', ').map((item) => `app-link_${item}`);
  }

  get correctHref() {
    const { href } = this;
    return href.startsWith('http://') || href.startsWith('https://')
      ? href
      : `https://${href}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/links/AppRegularLink/AppRegularLink.vue